import Vue from 'vue'
import Router from 'vue-router'
import DefaultLayout from './views/layouts/DefaultLayout.vue'
import MainLayout from './views/layouts/MainLayout.vue'
import MapLayout from './views/layouts/MapLayout.vue'
import Tracking from './views/Tracking.vue'
import Fillgrid from './views/Fillgrid.vue'
import FillgridTemplate from './views/FillgridTemplate.vue'
import MediaPreview from './views/MediaPreview.vue'
import Dashboard from './views/Dashboard.vue'
import ReportCapacidadProductividad from './components/dashboard/ReportCapacidadProductividad.vue'
import ReportEstatusGestion from './components/dashboard/ReportEstatusGestion.vue'
import ReportConexion from './components/dashboard/ReportConexion.vue'
import Login from './views/Login.vue'
import RecoveryPassword from './views/RecoverPassword.vue'
import Profile from './views/profile/Profile.vue'
import AdminClients from './views/AdminClients.vue'
import AdminDomains from './views/AdminDomains.vue'
import AdminPermissions from './views/AdminPermissions.vue'
import AdminRoles from './views/AdminRoles.vue'
import AdminUsers from './views/AdminUsers.vue'
import AdminGroups from './views/AdminGroups.vue'
import AsyncTasks from './views/AsyncTasks.vue'
import ProjectProjects from './views/ProjectProjects.vue'
import ProjectCatalogs from './views/projects/ProjectCatalogs.vue'
import AdminDevices from './views/AdminDevices.vue'
import InitTest from './views/InitTest.vue'
import AttachmentsViewer from './views/AttachmentsViewer.vue'
import ComposeMessage from './views/messaging/ComposeMessage.vue'

import FillgridTest from './views/FillgridTest.vue'
import CookiesService from './services/support/CookiesService'
import config from './config'
import api, { redirectToPlatformLogin } from './api'

Vue.use(Router)

const routes = [
  {
    path: '',
    name: 'initTest',
    component: InitTest
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/recovery-password',
    name: 'recovery-password',
    component: RecoveryPassword
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/',
    name: 'home',
    component: MainLayout
  },
  {
    path: '/main',
    name: 'main',
    component: DefaultLayout,
    children: [
      {
        path: 'fillgrid',
        name: 'fillgridTemplate',
        component: FillgridTemplate
      },
      {
        path: 'fillgrid/:id',
        name: 'fillgridData',
        component: Fillgrid
      },
      {
        path: 'fillgridtest',
        name: 'fillgridDataTest',
        component: FillgridTest
      }
    ]
  },
  {
    path: '/tracking',
    name: 'tracking',
    component: MapLayout,
    children: [
      {
        path: '',
        name: 'mainTracking',
        component: Tracking
      }
    ]
  },
  {
    path: '/media-preview/:type',
    name: 'mediapreview',
    component: MediaPreview
  },
  {
    path: '/attachments/:id',
    name: 'attachments',
    component: AttachmentsViewer
  },
  {
    path: '/reportes',
    name: 'dash',
    component: Dashboard,
    children: [
      {
        path: 'capacidad-y-productividad',
        name: 'report_cp',
        component: ReportCapacidadProductividad
      },
      {
        path: 'estatus-de-gestion',
        name: 'report_eg',
        component: ReportEstatusGestion
      },
      {
        path: 'reporte-conexion',
        name: 'report_cx',
        component: ReportConexion
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: DefaultLayout,
    children: [
      {
        path: 'clientes',
        name: 'admin_clients',
        component: AdminClients
      },
      {
        path: 'dominios',
        name: 'admin_domains',
        component: AdminDomains
      },
      {
        path: 'permisos',
        name: 'admin_permissions',
        component: AdminPermissions
      },
      {
        path: 'roles',
        name: 'admin_roles',
        component: AdminRoles
      },
      {
        path: 'usuarios',
        name: 'admin_users',
        component: AdminUsers
      },
      {
        path: 'dispositivos',
        name: 'admin_devices',
        component: AdminDevices
      },
      {
        path: 'grupos',
        name: 'admin_groups',
        component: AdminGroups
      }
    ]
  },
  {
    path: '/project',
    name: 'project',
    component: DefaultLayout,
    children: [
      {
        path: 'proyectos',
        name: 'project_projects',
        component: ProjectProjects
      },
      {
        path: 'catalogos',
        name: 'project_catalogs',
        component: ProjectCatalogs
      }
    ]
  },
  {
    path: '/forms',
    name: 'forms',
    component: DefaultLayout,
    children: [
      {
        path: 'tareas_asincronas',
        name: 'async_tasks',
        component: AsyncTasks
      }
    ]
  },
  {
    path: '/messaging/',
    name: 'messaging',
    component: DefaultLayout,
    children: [
      {
        path: 'compose-message',
        name: 'compose-message',
        component: ComposeMessage
      }
    ]
  },
  {
    path: '/playground/v1',
    name: 'Playground v1',
    component: () => import('@/views/BMPlayground.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/playground/v2',
    name: 'Playground v2',
    component: () => import('@/views/BMPlayground2.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    /** Test de chat live */
    path: '/livechat/v1',
    name: 'Live Chat (v1)',
    component: () => import('@/views/BMLiveChat.vue'),
    meta: {
      requiresAuth: true
    }
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!CookiesService.get(config.jwtAccessTokenCookieName)) {
      redirectToPlatformLogin()
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
